'use strict';

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ClientFactory = require('./client');
var ManagerFactory = require('./manager');
var StorageFactory = require('./storage');

var FullProducerFactory = require('./producer');
var PartialProducerFactory = require('./producer/browser/Partial');

var OfflineProducerFactory = require('./producer/offline');

var MetricsFactory = require('./metrics');

var SettingsFactory = require('./utils/settings');

var ReadinessGateFacade = require('./readiness');

var keyParser = require('./utils/key/parser');
var Logger = require('./utils/logger');
var log = Logger('splitio');
var tracker = require('./utils/logger/timeTracker');

// cache instances created
var instances = {};

//
// Create SDK instance based on the provided configurations
//
function SplitFactory(settings, storage, gateFactory, sharedInstance) {
  var readiness = gateFactory(settings.startup.readyTimeout);

  // We are only interested in exposable EventEmitter
  var gate = readiness.gate;

  // Events name

  var SDK_READY = gate.SDK_READY,
      SDK_UPDATE = gate.SDK_UPDATE,
      SDK_READY_TIMED_OUT = gate.SDK_READY_TIMED_OUT;


  var producer = void 0;
  var metrics = void 0;

  switch (settings.mode) {
    case 'localhost':
      producer = sharedInstance ? undefined : OfflineProducerFactory(settings, readiness, storage);
      break;
    case 'producer':
    case 'standalone':
      {
        // We don't fully instantiate metrics and producer if we are creating a shared instance.
        producer = sharedInstance ? PartialProducerFactory(settings, readiness, storage) : FullProducerFactory(settings, readiness, storage);
        metrics = sharedInstance ? undefined : MetricsFactory(settings, storage);
        break;
      }
    case 'consumer':
      break;
  }
  // Start background jobs tasks
  producer && producer.start();
  metrics && metrics.start();

  // Ready promise
  var readyFlag = sharedInstance ? _promise2.default.resolve() : new _promise2.default(function (resolve) {
    return gate.on(SDK_READY, resolve);
  });

  gate.on(SDK_READY, function () {
    return tracker.stop(tracker.C.SDK_READY);
  });

  var api = (0, _assign2.default)(
  // Proto linkage of the EventEmitter to prevent any change
  (0, _create2.default)(gate),
  // GetTreatment
  ClientFactory(settings, storage),
  // Utilities
  {
    // Ready promise
    ready: function ready() {
      return readyFlag;
    },


    // Events contants
    Event: {
      SDK_READY: SDK_READY,
      SDK_UPDATE: SDK_UPDATE,
      SDK_READY_TIMED_OUT: SDK_READY_TIMED_OUT
    },

    // Destroy instance
    destroy: function destroy() {
      readiness.destroy();
      storage.destroy && storage.destroy();

      producer && producer.stop();
      metrics && metrics.stop();
    }
  });

  return api;
}

function SplitFacade(config) {
  // Tracking times.
  tracker.start(tracker.C.SDK_READY);
  tracker.start(tracker.C.SPLITS_READY);
  tracker.start(tracker.C.SEGMENTS_READY);

  var settings = SettingsFactory(config);
  var storage = StorageFactory(settings);
  var gateFactory = ReadinessGateFacade();

  var defaultInstance = SplitFactory(settings, storage, gateFactory);

  log.info('New Split SDK instance created.');

  return {

    // Split evaluation engine
    client: function client(key) {
      if (!key) {
        log.debug('Retrieving default SDK client.');
        return defaultInstance;
      }

      if (typeof storage.shared != 'function') {
        throw 'Shared Client not supported by the storage mechanism. Create isolated instances instead.';
      }

      var parsedkey = keyParser(key);
      var instanceId = parsedkey.matchingKey + '-' + parsedkey.bucketingKey;

      if (!instances[instanceId]) {
        var sharedSettings = settings.overrideKey(key);
        instances[instanceId] = SplitFactory(sharedSettings, storage.shared(sharedSettings), gateFactory, true);
        log.info('New shared client instance created.');
      } else {
        log.debug('Retrieving existing SDK client.');
      }

      return instances[instanceId];
    },


    // Manager API to explore available information
    manager: function manager() {
      log.info('New manager instance created.');
      return ManagerFactory(storage.splits);
    },


    // Logger wrapper API
    Logger: Logger.API,

    // Expose SDK settings
    settings: settings
  };
}

module.exports = SplitFacade;


//////////////////
// WEBPACK FOOTER
// ../~/@splitsoftware/splitio/lib/index.js
// module id = 1209
// module chunks = 0